/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import dtypeStrings from '@stdlib/ndarray-base-dtype-strings';
import DataType from '@stdlib/ndarray-dtype-ctor';
import objectAssign from '@stdlib/object-assign';


// VARIABLES //

var TABLE;


// FUNCTIONS //

/**
* Creates an object mapping supported data type strings to data type objects.
*
* @private
* @returns {Object} object mapping supported data type strings to data type objects
*/
function createTable() {
	var out;
	var dt;
	var i;

	dt = dtypeStrings();

	out = {};
	for ( i = 0; i < dt.length; i++ ) {
		out[ dt[ i ] ] = new DataType( dt[ i ] );
	}
	return out;
}


// MAIN //

/**
* Returns an object mapping supported data type strings to data type objects.
*
* @returns {Object} object mapping supported data type strings to data type objects
*
* @example
* var table = dtypeObjects();
* // returns {...}
*/
function dtypeObjects() {
	if ( TABLE === void 0 ) {
		TABLE = createTable(); // lazily create the table
	}
	return objectAssign( {}, TABLE );
}


// EXPORTS //

export default dtypeObjects;
